import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'adc-checkbox',
  templateUrl: './adc-checkbox.component.html',
  styleUrls: ['./adc-checkbox.component.scss'],
  standalone: false
})
export class AdcCheckboxComponent {
  @Input('data') data: any;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  onCheckboxChange(itemId: string) {
    const checkedItem = this.data.items.find((item: { itemId: string; }) => item.itemId === itemId);
    if (checkedItem) {
      this.valueChange.emit(checkedItem);
    }
  }
}
